import { Box, useTheme } from '@mui/material';
import { DeleteOutlineIcon } from 'assets/icons';
import ConfirmDeleteDialog from 'components/features/ConfirmDeleteDialog';
import { useSwipeable } from 'components/hooks';
import React, { FC, ReactNode } from 'react';

interface SwipeableListItemProps {
  children: ReactNode;
  handleDelete: () => void;
  handleSelected: () => void;
  confirmDeleteTitle: string;
  confirmDeleteContent: string;
}

const SwipeableItem: FC<SwipeableListItemProps> = ({
  children,
  handleDelete,
  handleSelected,
  confirmDeleteTitle,
  confirmDeleteContent,
}) => {
  const {
    listElementRef,
    wrapperRef,
    backgroundRef,
    onDragStartMouse,
    onDragStartTouch,
    stateConfirmDeleteDialog,
    handleCancelDelete,
    handleDelete: handleDeleteTag,
  } = useSwipeable({
    onDelete: handleDelete,
    onSelected: handleSelected,
  });
  const theme = useTheme();

  return (
    <Box
      component='div'
      ref={wrapperRef}
      sx={{
        width: '100%',
        position: 'relative',
        transition: 'max-height 0.5s ease',
        transformOrigin: 'top',
        overflow: 'hidden',
        cursor: 'pointer',
      }}
    >
      <Box
        component='div'
        ref={backgroundRef}
        sx={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          zIndex: -1,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          alignItems: 'center',
          paddingRight: '16px',
          boxSizing: 'border-box',
        }}
      >
        <Box
          component='div'
          sx={{
            width: 50,
            height: 45,
            borderRadius: '4px',
            backgroundColor: theme.palette.error.main,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <DeleteOutlineIcon
            sx={{ fill: '#fff', fontSize: '40px', margin: 'auto' }}
          />
        </Box>
      </Box>
      <Box
        component='div'
        className='BouncingListItem'
        ref={listElementRef}
        onMouseDown={onDragStartMouse}
        onTouchStart={onDragStartTouch}
      >
        <Box
          component='div'
          sx={{
            width: '100%',
            minHeight: '60px',
            padding: '11px',
            textAlign: 'left',
            border: '1px solid',
            borderColor: theme.palette.primary.main,
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {children}
        </Box>
      </Box>
      <ConfirmDeleteDialog
        open={stateConfirmDeleteDialog}
        handleClose={handleCancelDelete}
        confirmTitle={confirmDeleteTitle}
        confirmContent={confirmDeleteContent}
        handleConfirm={handleDeleteTag}
      />
    </Box>
  );
};

export default SwipeableItem;
